import { Icon, IconProps } from "@chakra-ui/react";

export default function OrangeFlower(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <path
        d="M5.475 9L8.3 6.175L7.575 5.45L5.4625 7.5625L4.4125 6.5125L3.7 7.225L5.475 9ZM3 11C2.725 11 2.48967 10.9022 2.294 10.7065C2.09833 10.5108 2.00033 10.2753 2 10V2C2 1.725 2.098 1.48967 2.294 1.294C2.49 1.09833 2.72533 1.00033 3 1H7L10 4V10C10 10.275 9.90217 10.5105 9.7065 10.7065C9.51083 10.9025 9.27533 11.0003 9 11H3ZM6.5 4.5V2H3V10H9V4.5H6.5Z"
        fill="white"
      />
    </Icon>
  );
}
